import React, { useState } from 'react';

import { Form, FormItemProps, Select, Tag } from 'antd';
import { t } from 'i18next';

import { useGetUsersListQuery } from '../store/usersApi';

interface Props {
  formProps?: FormItemProps;
  oneSelectMode?: boolean;
}

export function SelectUsers({ formProps, oneSelectMode }: Props) {
  const [search, setSearch] = useState('');
  const { data: { items: users } = { items: [] }, isLoading } = useGetUsersListQuery({ name: search, role: 'user' });

  if (isLoading) {
    return null;
  }

  return (
    <Form.Item label={t(`booked-court.titles.${oneSelectMode ? 'user-name' : 'user-names'}`)} name={oneSelectMode ? 'userId' : 'usersId'} {...formProps}>
      < Select
        optionFilterProp="searchText"
        showSearch
        onSearch={setSearch}
        {...(oneSelectMode ? {} : { mode: 'multiple' })}
        filterSort={(optionA, optionB) =>
          (optionA?.searchText ?? '').toLowerCase().localeCompare((optionB?.searchText ?? '').toLowerCase())}
        options={users.filter((user) => user.id !== 100000).map((user) => ({
          label: `${user.name}  (ID: ${user.id}, ${user.balance}₽)`,
          value: user.id,
          searchText: user.name,
        }))}
        tagRender={({ value, closable, onClose }) => (
          <Tag
            style={{
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              marginRight: '5px',
              backgroundColor: '#f0f0f0',
            }}
          >
            {users.find((user) => user.id === value)?.name}
            {closable && (
              <span onClick={onClose} style={{ marginLeft: '5px', fontSize: '16px', cursor: 'pointer' }}>
                &times;
              </span>
            )}
          </Tag>
        )}
      />
    </Form.Item >
  );
}
